<script>
import NxtTasksApp from "@nextories/vue-tasks/src/components/templates/NxtTasksApp.vue";
import { mapActions } from "pinia";
import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore.ts";

export default {
  extends: NxtTasksApp,
  data() {
    return {
      listDiffRoutesHome: ['project', 'projects', 'history', 'movers', 'dashboard'],
    }
  },
  computed: {
    isLocationDashboard() {
      return (window.location.pathname === '/'
        || window.location.pathname.indexOf('/?') !== -1);
    },
    isLocationHomeProject() {
      return (window.location.pathname === '/tasks'
        || window.location.pathname.indexOf('/tasks?') !== -1
        || this.isLocationProject || this.isLocationDashboard);
    },
    checkRouteInitTasks() {
      return !this.isLocationHistory && !this.isLocationProject && !this.isLocationDashboard;
    },
  },
  methods: {
    ...mapActions(useUsersStore, [
      "setIsAssignedNotUser",
    ]),
    async initApp() {
      try {
        await this.getUsers();
        await this.initHistory();
        await this.setInitialNotesFilters();
        if (this.currentUser && !this.currentUser.is_admin) {
          this.setIsAssignedNotUser(false);
        }
        if (((this.isLocationHistory || this.isLocationHomeProject) && !this.isLoadedTasks)
          || this.isLocationLogin) {
          if (this.isLocationLogin) {
            await this.initTasks(true, 'dashboard', false);
          } else {
            await this.initTasks(false);
          }
        }
      } catch (error) {
        this.redirectToLogin(error);
      }
    },
  },
};
</script>

<template>
  <nxt-tasks-easter-egg-rotate v-if="isInit" class="app__wrapper">
    <nxt-tasks-layout :root-store="rootStore" class="app__layout">
      <RouterView />
    </nxt-tasks-layout>
  </nxt-tasks-easter-egg-rotate>
  <div v-else class="app__wrapper">
    <loader :class="$vClass('loading')" :text="$t('base.loading')" sizeLoader="--size-small" />
  </div>
</template>

<style lang="scss">
@use "@nextories/vue-tasks/src/assets/scss/app";

.app {
  @include breakpoint(desktop) {
    .navbar.el-header#navbar-header {
      height: 60px;
      border-bottom: var(--nxt-border-default) var(--nxt-color-light-grey-blue);
      padding-bottom: var(--nxt-space-medium);
    }
  }
}
</style>
